module.exports = __webpack_public_path__ + "img/section4Logo2.078104e6.svg";